import {Theme} from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = (theme: Theme) => createStyles({
    name: {
        '@media screen and (max-width: 500px)': {
            display: 'none'
        }
    }
});